var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.375C4.275 0.375 0.375 4.275 0.375 9C0.375 10.8 0.9 12.45 1.875 13.875L0.9 16.8C0.825 16.95 0.9 17.1 0.975 17.175C1.125 17.25 1.275 17.325 1.425 17.25L4.425 16.275C5.775 17.175 7.425 17.625 9 17.625C13.725 17.625 17.625 13.725 17.625 9C17.625 4.275 13.725 0.375 9 0.375ZM14.175 12.525C13.95 13.2 13.05 13.8 12.3 13.95C12.15 13.95 12 14.025 11.775 14.025C11.175 14.025 10.425 13.8 9.225 13.35C7.725 12.75 6.225 11.4 5.025 9.675L4.95 9.6C4.5 9 3.825 7.95 3.825 6.825C3.825 5.55 4.5 4.875 4.725 4.575C5.025 4.275 5.4 4.125 5.85 4.125H6.075H6.15C6.525 4.125 6.75 4.275 6.975 4.725L7.125 5.025C7.35 5.55 7.65 6.375 7.725 6.525C7.875 6.825 7.875 7.05 7.725 7.275C7.65 7.425 7.575 7.575 7.425 7.725C7.35 7.8 7.275 7.875 7.275 7.95C7.2 8.025 7.125 8.1 7.05 8.175V8.25C7.275 8.625 7.725 9.3 8.325 9.825C9.15 10.575 9.75 10.8 10.05 10.95H10.125C10.2 10.95 10.275 11.025 10.275 10.95C10.425 10.8 10.575 10.5 10.8 10.275L10.875 10.2C11.1 9.9 11.4 9.825 11.55 9.825C11.625 9.825 11.775 9.825 11.85 9.9C11.925 9.9 12.075 9.975 13.5 10.725L13.65 10.8C13.875 10.875 14.025 10.95 14.1 11.175C14.4 11.325 14.325 12 14.175 12.525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.fdd5cd2c25a761ecea9e3908f34cc4d6.svg";
export { ForwardRef as ReactComponent };